
import React from 'react';
import { styled } from '@mui/system';
import { COLORS } from 'src/constants';
import { Typography } from 'src/components';
import { CircularProgress, Switch } from '@mui/material';

export const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export const Panel = styled('div')`
padding: 20px 0;
border-bottom: 1px solid ${COLORS.borderNavy};

&:first-of-type {
  border-top: 1px solid ${COLORS.borderNavy};
}`;

export const Title = styled('h4')`
  margin-bottom: 20px;
`;

export const SubTitle = styled('div')`
  font-size: 16px;
  font-weight: 700;
`;

export const DataValue = styled('div')`
  font-weight: 500;
  font-size: 14px;
`;

export const Divider = styled('div')`
margin-bottom: 10px;
border-bottom: 1px solid #EEE;
`;

export const IconButton = styled('div')`
cursor: pointer;
color: #324dc7;
font-weight: 700;
font-size: 0.875rem;
display: inline-block;

&:hover {
  color: #5d7af6;
}
`;
export const Highlight = styled('div')`
  font-weight: 500;
`;

export const ItemCard = styled('div')`
display: inline-flex; 
align-items: center;
`;


export const FieldRow = styled('div')`
margin-bottom:15px;
`;

export const ItemRow = styled('div')`
margin-bottom:20px;
`;

export const FieldLabel = styled(Typography)`

`;

export const SubFieldLabel = styled('div')`
  font-size: 12px;
  font-weight: 300;
`;


export const RadioLabel = styled(Typography)`
  margin-bottom: 4px;
`;
//font-weight: 600;

export type NoticeProps = {
  errorMessage: string | React.ReactNode;
};


export const ContainerInline = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const HeaderInline = styled('div')`
  display: flex;
  align-items: center;
`;

export const FieldNote = styled('i')`
  font-size: 12px; 
  color: #818181;
`;

export const ErrorNotice: React.FC<NoticeProps> = ({ errorMessage }) => {
  return <ContainerInline>
    <HeaderInline style={{ marginBottom: '6px' }}>
      <i style={{ marginRight: '10px' }} className="cb-icon cb-icon-circular cb-exclamation cb-red1-color"></i>
      <h4 className="cb-notification-title"><strong>Errors Occurred</strong></h4>
    </HeaderInline>
    <div style={{ marginLeft: '42px' }} className="cb-notification-content">
      {errorMessage}
    </div>
  </ContainerInline>;
};

export const Loader: React.FC = () => {
  return <ContainerInline>
    <HeaderInline style={{ marginBottom: '6px' }}>
      <CircularProgress style={{ marginRight: '10px' }} />
      <h4 className="cb-notification-title"><strong>Loading...</strong></h4>
    </HeaderInline>
  </ContainerInline>;
};